import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './user/Navbar';
import Footer from './user/Footer';

export default function StorefrontLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
